<script setup lang="ts">

</script>

<template>
  <div class="lds-ellipsis">
    <div/>
    <div/>
    <div/>
    <div/>
  </div>
</template>

<style scoped lang="scss">

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 100%;
  transform: scale(0.8);
}
.lds-ellipsis div {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);

  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: currentColor;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0) translateY(-50%);
  }
  100% {
    transform: scale(1) translateY(-50%);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1) translateY(-50%);
  }
  100% {
    transform: scale(0) translateY(-50%);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0) translateY(-50%);
  }
  100% {
    transform: translate(24px, 0) translateY(-50%);
  }
}
</style>